export const CircleSmall = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17.625 12C17.625 15.1289 15.0938 17.625 12 17.625C8.87109 17.625 6.375 15.1289 6.375 12C6.375 8.90625 8.87109 6.375 12 6.375C15.0938 6.375 17.625 8.90625 17.625 12Z" fill="#101828" />
</svg>;
